import { oneLine } from 'common-tags';

import type { FunctionComponent } from 'react';
import type { TypeNotificationsProps } from './types';

const StylesByStateBox = {
  OK: 'bg-[#e7f1da]',
  ERROR: 'bg-[#FFE8E8]',
  INFO: 'bg-primary-100',
};

const StylesByStateText = {
  OK: 'text-status-success',
  ERROR: 'text-status-error',
  INFO: 'text-primary-900',
};

/**
 * Notifications
 */
export const Notifications: FunctionComponent<TypeNotificationsProps> = ({
  message,
  state,
  Icon,
  box = true,
  className = '',
}: TypeNotificationsProps) => (
  <div
    // prettier-ignore
    // eslint-disable-next-line sonarjs/no-nested-template-literals
    className={oneLine`
      u-body flex flex-row items-start justify-start gap-2
      ${box ? `u-body--s p-2 ${StylesByStateBox[state]}` : 'u-body--xs'}
      ${StylesByStateText[state]}
      ${className}
    `}
  >
    {Icon && <Icon width={19} height={19} className="shrink-0" />}

    <p>{message}</p>
  </div>
);

Notifications.displayName = 'Notifications';
